import { useCallback } from 'react'
import { gql, useLazyQuery } from '@apollo/client'

import { useGoogleMarker } from 'packages/wimap/Google'
import { availableToColor } from 'pages/Supervision/helpers'

import PopupContent from './PopupContent'

const OPERATION_SURFACE_AREAS = gql`
  query GetSiteAreas($id: String!) {
    site: findSite(sf_id: $id) {
      ... on Site {
        name
        sf_id
        building_equipment {
          name
          accesspoint_unreachable
          accesspoint_ok
          switch_unreachable
          switch_ok
          available_level
          active_users
        }
      }
      surface_areas {
        uuid
        name
        floor_count
      }
    }
  }
`

const useMarkers = ({ google, map, infoWindow, onMarkerClick, disablePopup = false }) => {
  const [getSiteArea] = useLazyQuery(OPERATION_SURFACE_AREAS)
  
  const color = useCallback(
    (site) => {
      const availableLevel = site?.isSurfaceArea
        ? site?.buildingEquipment?.available_level ?? 'notReferenced'
        : site?.equipment?.available_level

      return availableToColor(availableLevel ?? 'down')
    },
    [],
  )

  const markerPopupContent = useCallback(async (marker) => {
    if (!marker.sf_id) {
      return null
    }
    
    const { data} = await getSiteArea({
      variables: { id: marker.sf_id },
    })
    if (data) {
      const buildingData = marker.isSurfaceArea ? {
        name: marker.name,
        equipment: data.site.building_equipment.find(eq => eq.name === marker.name)
      } : null

      return (
        <PopupContent
          site={marker}
          notSupervised={marker.state?.toLowerCase() === 'etude'}
          color={color(marker)}
          buildingData={buildingData}
        />
      )
    }

  }, [color, getSiteArea])

  return useGoogleMarker({
    google,
    map,
    infoWindow,
    onClick: onMarkerClick,
    color,
    popupContent: markerPopupContent,
    iconType: site => site.isSurfaceArea ? 'house' : 'default',
    disablePopup
  })
}

export default useMarkers
